// import logo from './logo.svg';
import 'core-js/stable/global-this';
import './Sass/main.sass'
// import ModulosPeopleContainer from "./Containers/People/Modules";
import C13PeopleOrg from './Components/Organisms/Personas/C13'

function App() {
  return (
    <div className="App">
      <C13PeopleOrg />
    </div>
  );
}

export default App;
